import it from './it.json'
import cz from './cz.json'

export const languages = {
  it: it,
  cz: cz,
}